module.exports = angular.module('cartographer.common.validate', [])

$      = require 'jquery'
_      = require 'underscore'
moment = require 'moment'

# coffeelint: disable=no_unnecessary_fat_arrows

module.exports.factory 'crtValidate', $DI (crtLog, crtString, crtNumber, crtLocation, crtDatetime) ->
  class Validator
    constructor: (@value, @errors) ->
      # Do nothing

    # or(string function) -> (any -> any)
    _createAccessor: (accessor) =>
      if _.isString(accessor)
        names = accessor.split(".")
        (obj) -> _.foldl(names, ((obj, name) -> obj?[name]), obj)
      else if _.isFunction(accessor)
        (obj) -> accessor(obj)
      else
        throw [ 'bad.accessor', accessor ]

    # (any... -> or(arrayOf(partialError), partialError, string, undefined)) -> (any... -> arrayOf(partialError))
    _createValidator: (validator) =>
      (args...) ->
        ans = validator(args...)
        if _.isArray(ans)
          ans
        else if _.isString(ans)
          [{ level: 'error', message: ans }]
        else if _.isObject(ans)
          [ans]
        else
          []

    # or(array function) -> (arrayOf(partialError) -> arrayOf(error))
    _createNormalizer: (accessor) ->
      (errors) ->
        _.map errors, (error) ->
          return {
            level: error.level ? 'error'
            field: if _.isString(accessor)
              if error.field then "#{accessor}.#{error.field}" else accessor
            else
              error.field
            message: error.message
          }

    # or(array function) -> (arrayOf(partialError) integer -> arrayOf(error))
    _createArrayNormalizer: (accessor) ->
      (errors, index) ->
        _.map errors, (error) ->
          return {
            level: error.level ? 'error'
            field: if _.isString(accessor)
              if error.field
                "#{accessor}[#{index}].#{error.field}"
              else
                "#{accessor}[#{index}]"
            else
              error.field
            message: error.message
          }

    # or(array function) -> (arrayOf(partialError) integer -> arrayOf(error))
    _createObjectNormalizer: (accessor) ->
      (errors, field) ->
        _.map errors, (error) ->
          return {
            level: error.level ? 'error'
            field: if _.isString(accessor)
              if error.field then "#{accessor}.#{field}.#{error.field}" else accessor
            else
              error.field
            message: error.message
          }

    field: (accessor, validator) =>
      _access    = @_createAccessor(accessor)
      _validate  = @_createValidator(validator)
      _normalize = @_createNormalizer(accessor)
      @errors    = @errors.concat(_normalize(_validate(_access(@value))))
      this

    arrayField: (accessor, validator) =>
      _access    = @_createAccessor(accessor)
      _validate  = @_createValidator(validator)
      _normalize = @_createArrayNormalizer(accessor)
      for item, index in _access(@value)
        @errors = @errors.concat(_normalize(_validate(item, index), index))
      this

    objectField: (accessor, validator) =>
      _access    = @_createAccessor(accessor)
      _validate  = @_createValidator(validator)
      _normalize = @_createObjectNormalizer(accessor)
      _.each _.pairs(_access(@value)), ([ field, value ]) =>
        @errors = @errors.concat(_normalize(_validate(field, value), field))
        return
      this

    whole: (validator) =>
      _access    = (x) -> x
      _validate  = @_createValidator(validator)
      _normalize = @_createNormalizer((x) -> x)
      @errors    = @errors.concat(_normalize(_validate(_access(@value))))
      this

    finish: =>
      @errors

  create = (value, errors = []) ->
    new Validator(value, errors)

  # Useful validators ---------------------------

  pastDatetime = (message, field = undefined) ->
    (value) ->
      if _.isDate(value) and moment(value).isAfter(moment().endOf('day'))
        { level: "error", field, message }

  recorded = (field = undefined) ->
    (value) ->
      if !value
        { level: "warning", field, message: "You should specify the survey date." }
      else
        pastDatetime("The survey date cannot be in the future!", field)(value)

  surveyor = (field = undefined) ->
    (value) ->
      if !value
        { level: "error", field, message: "Surveyor data is missing from the underlying survey data." }
      else if !value.screenName || value.screenName == ""
        { level: "warning", field, message: "You should specify a surveyor." }
      # else
      # if value.name && !value.userId
      #   { level: "warning", field, message: "The survey is not linked to a registered user account." }

  passwordStrengthHint = "Passwords must be at least six characters and contain upper and lower case letters, digits, and punctuation."

  password = (field = undefined) ->
    (value) ->
      if value && value.length > 0
        lengthOk = value.length >= 6
        letterOk = value.match(/[a-z]/i)?
        digitOk  = value.match(/[0-9]/i)?
        otherOk  = value.match(/[^a-z0-9]/i)?
        if !lengthOk || !letterOk || !digitOk || !otherOk
          { level: "error", message: passwordStrengthHint }

  ukLocation = (field = undefined) ->
    (value) ->
      if !value || !crtLocation.isGeometry(value)
        { field, message: "You must specify a location." }
      else if !crtLocation.formatNgr(value)
        { field, message: "You must specify a location in the UK." }

  pass = () ->
    (value) ->
      []

  required = (message, level = undefined, field = undefined) ->
    level ?= if /should/i.test(message) then 'warning' else 'error'
    (value) ->
      if !value? || (_.isString(value) && $.trim(value) == "")
        { level, field, message }

  forbidden = (message, level = undefined, field = undefined) ->
    level ?= if /should/i.test(message) then 'warning' else 'error'
    (value) ->
      if value? && !(_.isString(value) && $.trim(value) == "")
        { level, field, message }

  nonEmpty = (message, level = undefined, field = undefined) ->
    level ?= if /should/i.test(message) then 'warning' else 'error'
    (value) ->
      if value.length == 0
        { level, field, message }

  lengthGte = (len, message, level = undefined, field = undefined) ->
    level ?= if /should/i.test(message) then 'warning' else 'error'
    (value) ->
      if value.length < len
        { level, field, message }

  lengthLte = (len, message, level = undefined, field = undefined) ->
    level ?= if /should/i.test(message) then 'warning' else 'error'
    (value) ->
      if value.length > len
        { level, field, message }

  optional = (validator) ->
    (value) ->
      if value? && value != "" then validator(value) else []

  integer = (message = "Must be a whole number.", level = undefined, field = undefined) ->
    (value) ->
      if typeof value != "number" || !crtNumber.isInteger(value)
        { level, field, message}

  nonNegative = (message = "Must be 0 or greater.", level = undefined, field = undefined) ->
    level ?= if /should/i.test(message) then 'warning' else 'error'
    (value) ->
      if typeof value != "number" || value < 0
        { level, field, message }

  oneOf = (collection, message = "Must be one of the permitted values.", level = undefined, field = undefined) ->
    level ?= if /should/i.test(message) then 'warning' else 'error'
    (value) ->
      unless _.contains(collection, value)
        { level, field, message }

  gt = (target, message, level = undefined, field = undefined) ->
    level ?= if /should/i.test(message) then 'warning' else 'error'
    (value) ->
      if typeof value == "number" && value <= target
        { level, field, message }

  gte = (target, message, level = undefined, field = undefined) ->
    level ?= if /should/i.test(message) then 'warning' else 'error'
    (value) ->
      if typeof value == "number" && value < target
        { level, field, message }

  lt = (target, message, level = undefined, field = undefined) ->
    level ?= if /should/i.test(message) then 'warning' else 'error'
    (value) ->
      if typeof value == "number" && value >= target
        { level, field, message }

  lte = (target, message, level = undefined, field = undefined) ->
    level ?= if /should/i.test(message) then 'warning' else 'error'
    (value) ->
      if typeof value == "number" && value > target
        { level, field, message }

  inclusiveRange = (lower, upper, message, level = undefined, field = undefined) ->
    level ?= if /should/i.test(message) then 'warning' else 'error'
    (value) ->
      if typeof value == "number" && (value < lower || value > upper)
        { level, field, message }

  timeString = (message, level = undefined, field = undefined) ->
    level ?= if /should/i.test(message) then 'warning' else 'error'
    (value) ->
      if !crtDatetime.isTimeString(value)
        { level, field, message }

  nonEmptyArray = (message, level = undefined, field = undefined) ->
    level ?= if /should/i.test(message) then 'warning' else 'error'
    (value) ->
      if value?.length == 0
        { level, field, message }

  email = (message, level = undefined, field = undefined) ->
    level ?= if /should/i.test(message) then 'warning' else 'error'
    (value) ->
      unless crtString.isEmail(value)
        { level, field, message }

  matchesRegex = (regex, message, level = undefined, field = undefined) ->
    level ?= if /should/i.test(message) then 'warning' else 'error'
    (value) ->
      unless typeof value == 'string' && regex.test(value)
        { level, field, message }

  return {
    create
    pastDatetime
    recorded
    forbidden
    surveyor
    passwordStrengthHint
    password
    ukLocation
    pass
    required
    nonEmpty
    lengthGte
    lengthLte
    optional
    integer
    nonNegative
    oneOf
    gt
    gte
    lt
    lte
    inclusiveRange
    timeString
    nonEmptyArray
    email
    matchesRegex
  }
